import { Injectable } from '@angular/core';

import { DataSecurityService } from '../../shared/services/data-security.service';
import { WindowService } from '../../shared/services/window.service';

@Injectable()
export class PwaDataSecurityService extends DataSecurityService {

    constructor(private readonly windowService: WindowService) {
        super();
    }

    public get securityLevel(): DataSecurityLevel {
        return this.windowService.nativeWindow.windowsDataSecuritySetting || DataSecurityLevel.Security;
    }
}
